import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { ASK_FOR_HELP } from "../community/constants";

export default function AddAskForHelpPage() {
  return <CommunityAddPage section={ASK_FOR_HELP} />;
}
